import { render, staticRenderFns } from "./WithholdingTaxCertificate.vue?vue&type=template&id=350823d4&"
import script from "./WithholdingTaxCertificate.vue?vue&type=script&lang=js&"
export * from "./WithholdingTaxCertificate.vue?vue&type=script&lang=js&"
import style0 from "./WithholdingTaxCertificate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardText,
  VContainer,
  VDataTable,
  VDialog,
  VFlex,
  VIcon,
  VLayout,
  VPagination,
  VProgressLinear,
  VSelect,
  VSnackbar,
})
